import { render, staticRenderFns } from "./SearchSendNm.vue?vue&type=template&id=73d56f64&scoped=true&"
import script from "./SearchSendNm.vue?vue&type=script&lang=js&"
export * from "./SearchSendNm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d56f64",
  null
  
)

export default component.exports